import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from './assets/notes.png'
import _imports_1 from './assets/split_line.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "current_keyword" }, "常用搜索词：", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "split_line"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "网站备案号:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "皖ICP备2021015452号", -1)

import { ref, reactive, onMounted, onUpdated } from "vue";
import { Search, EditPen } from "@element-plus/icons-vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";

import type Node from 'element-plus/es/components/tree/src/model/node'
import type { DragEvents } from 'element-plus/es/components/tree/src/model/useDragNode'
import type { NodeDropType } from 'element-plus/es/components/tree/src/tree.type'
import { TreeNode } from "element-plus";
import { getKeywords } from "./apis/notes";
import axios from 'axios'

interface Tree {
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();

const keywords = reactive<Tree[]>([])
onMounted(() => {
  keywords.length = 0
  getKeywords().then((res) => {
    for(let keyword of res.data) {
      keywords.push({label: keyword})
    }
  })
});

onUpdated(() => {
  console.log("onUpdated1");
});

const keyword = ref('');

const store = useStore();

function gotoHome() {
  router.push("/");
}

const handleDragStart = (node: Node, ev: DragEvents) => {
  console.log('drag start', node)
}
const handleDragEnter = (
  draggingNode: Node,
  dropNode: Node,
  ev: DragEvents
) => {
  console.log('tree drag enter:', dropNode.label)
}
const handleDragLeave = (
  draggingNode: Node,
  dropNode: Node,
  ev: DragEvents
) => {
  console.log('tree drag leave:', dropNode.label)
}
const handleDragOver = (draggingNode: Node, dropNode: Node, ev: DragEvents) => {
  console.log('tree drag over:', dropNode.label)
}
const handleDragEnd = (
  draggingNode: Node,
  dropNode: Node,
  dropType: NodeDropType,
  ev: DragEvents
) => {
  console.log('tree drag end:', dropNode && dropNode.label, dropType)
}
const handleDrop = (
  draggingNode: Node,
  dropNode: Node,
  dropType: NodeDropType,
  ev: DragEvents
) => {
  console.log('tree drop:', dropNode.label, dropType)
}
const allowDrop = (draggingNode: Node, dropNode: Node, type: NodeDropType) => {
  if (dropNode.data.label === 'Level two 3-1') {
    return type !== 'inner'
  } else {
    return true
  }
}
const allowDrag = (draggingNode: Node) => {
  return !draggingNode.data.label.includes('Level three 3-1-1')
}

const search = () => {
  requestData(keyword.value);
}

const openNotes = (node: Node) => {
  requestData(node.label);
}

const requestData = (searchKeyword: string) => {
  router.push("/")
  axios.get(`jingtu/notes/${searchKeyword}`).then((resp) => {
    store.commit("changeContents", resp.data);
    keywords.length = 0
    getKeywords().then((res) => {
      for(let keyword of res.data) {
        keywords.push({label: keyword})
      }
    })
  }).catch((err) => {
    console.log(err)
  })
}

const takeNotes = () => {
  router.push("/take_notes")
}

const data = [
  {
    label: 'Flink学习笔记',
    children: [
      {
        label: '尚硅谷Flink笔记',
      },
      {
        label: '易学Flink笔记',
      },
      {
        label: 'java',
      },
    ],
  },
]

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, { class: "box-header" }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                class: "logo_notes",
                onClick: gotoHome
              }),
              _createVNode(_component_el_icon, {
                size: 22,
                class: "edit_pen",
                onClick: takeNotes
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(EditPen))
                ]),
                _: 1
              }),
              _createVNode(_component_el_input, {
                placeholder: "按回车键 (Enter) 进行搜索",
                "prefix-icon": _unref(Search),
                class: "keyword_search",
                modelValue: keyword.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
                onKeyup: _withKeys(search, ["enter"])
              }, null, 8, ["prefix-icon", "modelValue", "onKeyup"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "box-left" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createVNode(_component_el_tree, {
                    class: "keyword_s",
                    data: keywords,
                    onNodeClick: openNotes
                  }, null, 8, ["data"]),
                  _hoisted_2,
                  _createVNode(_component_el_tree, {
                    class: "tree_s",
                    "allow-drop": allowDrop,
                    "allow-drag": allowDrag,
                    data: data,
                    draggable: "",
                    "default-expand-all": "",
                    "node-key": "id",
                    onNodeDragStart: handleDragStart,
                    onNodeDragEnter: handleDragEnter,
                    onNodeDragLeave: handleDragLeave,
                    onNodeDragOver: handleDragOver,
                    onNodeDragEnd: handleDragEnd,
                    onNodeDrop: handleDrop,
                    onNodeClick: openNotes
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, { class: "p-center" }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})